import React from "react";

// Approved customer testimonial, rendered directly beneath the hero action row on the solutions
// pages via CalloutSection. Kept here so both pages carry identical wording and attribution — the
// quote is customer-approved copy, so edit the words only with fresh sign-off.
export const intakeBreathingQuote: React.ReactNode = (
  <>
    For the first time, all of our channels — Shopify, Amazon, TikTok, subscriptions — live in{" "}
    <em>one place we can actually trust.</em> The best part is being able to explore it ourselves.
    It works so well. The DataFabrIQ team replaced the reports we used to assemble by hand with
    live dashboards, and the turnaround has been remarkably quick. It genuinely feels like an
    extension of our team.
  </>
);

export const intakeBreathingCite = "— Marjolijn Zwart · Head of FP&A, Intake Breathing";
